import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const UnderLineIcon = (props) => {
  return (
    /*
    <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 20 20"
      width="13"
      style={ { paddingTop:"2px", paddingLeft:"2px" } }
    >
     <g id="layer1">
       <path d="M 5 4 L 5 13 C 5 15.24182 7.0544185 17 9.5 17 C 11.945581 17 14 15.24182 14 13 L 14 4 L 13 4 L 13 13 C 13 14.624174 11.472697 16 9.5 16 C 7.5273035 16 6 14.624174 6 13 L 6 4 L 5 4 z M 3 19 L 3 20 L 16 20 L 16 19 L 3 19 z " 
        />
     </g>
    </svg>*/

  
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="8.000000pt" height="8.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M853 3898 c4 -1323 2 -1281 58 -1488 116 -427 381 -785 754 -1017
263 -163 580 -253 895 -253 586 0 1124 297 1443 797 119 186 199 398 243 643
16 86 18 215 21 1318 l4 1222 -355 0 -356 0 0 -1122 c0 -689 -4 -1165 -10
-1233 -14 -144 -40 -238 -100 -360 -285 -578 -1029 -734 -1531 -320 -139 114
-272 320 -318 495 -37 139 -41 260 -41 1418 l0 1122 -356 0 -355 0 4 -1222z"/>
<path d="M570 285 l0 -285 1990 0 1990 0 0 285 0 285 -1990 0 -1990 0 0 -285z"/>
</g>
</svg>

  );
};

export default UnderLineIcon;
